<button class="btn btn-warning btn-xs  ml-1">
  <i class="fa fa-lg  fa-sync   cpointer" title="sincronizar com keeta" kendoTooltip
     (click)="sincronizarStatusPedido($event)"
     [hidden]="pedido.sincronizando">
  </i>

  <i class="k-icon k-i-loading fa-lg" *ngIf="pedido.sincronizando"></i>

</button>
